import { render, staticRenderFns } from "./RestorePasswordForm.vue?vue&type=template&id=7343cf3a&scoped=true&"
import script from "./RestorePasswordForm.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authorization.css?vue&type=style&index=0&id=7343cf3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7343cf3a",
  null
  
)

export default component.exports